// Import Swiper styles
import 'swiper/css'

import { Fragment, useEffect } from 'react'
// import required modules
import { Autoplay } from 'swiper/modules'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

import { useMain } from '@/contexts/mainContext'

import bancodeperucamovelArr from '../utils/bancodeperucamovelslide.json'

export function SlideBancoDePerucasMovel() {
  const { bancoDePerucasMovelSlide, setBancoDePerucasMovelSlide } = useMain()

  useEffect(() => {
    const response = bancodeperucamovelArr

    setBancoDePerucasMovelSlide(response)
  }, [setBancoDePerucasMovelSlide])

  return (
    <Swiper
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      modules={[Autoplay]}
    >
      {bancoDePerucasMovelSlide.map((slide) => {
        return (
          <Fragment key={slide.id}>
            {slide.show === true && (
              <SwiperSlide>
                <img
                  src={`assets/slides/bancodeperucasmovel/${slide.imagem}`}
                  alt={`Banco de Peruca Móvel ${slide.id}`}
                  className="h-[550px] object-contain max-[1024px]:object-cover"
                />
              </SwiperSlide>
            )}
          </Fragment>
        )
      })}
    </Swiper>
  )
}
